import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Offerte } from '../model/offerte';
import { Datipreventivo } from '../model/datipreventivo';
import { FornitoreServiceService } from '../service/fornitore-service.service';
import { CollapseModule } from 'angular-bootstrap-md';
import { ComparatoretaskService } from '../service/comparatoretask.service';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-offertecomparatore',
  templateUrl: './offertecomparatore.component.html',
  styleUrls: ['./offertecomparatore.component.scss']
})
export class OffertecomparatoreComponent implements OnInit {

  private changedati;
  private _dati: Datipreventivo;
  private _importo:number;
  private _importonetto:number;
  public  linkfoto:string;

  @Input() offerta: Offerte;
  @Input() indice: number;
  @Input('dati') set dati(dato: Datipreventivo) {
     
    this._dati=  dato;
     this._importo=this.servicecomparatore.getimporto(this._dati, this.offerta);
     this._importonetto= this.servicecomparatore.getimportoNetto(this._dati, this.offerta);
     this.linkfoto=null;
     this.servicefornitore.getFotofornitoribyId(this.offerta.Id_Foritore).subscribe(data => this.linkfoto=data);

  }
  @Input() stateOfferta: number;
  @Output() onClickChangeState: EventEmitter<any> = new EventEmitter();

  isCollapsed: any;

  constructor(private servicefornitore: FornitoreServiceService, private servicecomparatore: ComparatoretaskService) { }

  ngOnInit() {
    // this.changedati = true;
  }

  get importo() {
    if (this._dati == null)
      return 0;

    return this._importo;

  }

  //abbiamo aggiunto Observable 
  public getfotofornitore():  string {

    
     return this.linkfoto;
  }

  public clickChiama() {
    this.onClickChangeState.emit(this.offerta.NomeOfferta);
  }

 get copertura()
 {
   return this.servicecomparatore.iscopertura(this._dati,this.offerta);
 }
  get importoNetto() {
    if (this._dati == null)
      return 0;

    return this._importonetto;

  }

  get importoImposte() {
    if (this._dati == null)
      return 0;

    return this._importo - this._importonetto;

  }

}



// WEBPACK FOOTER //
// ./src/app/offertecomparatore/offertecomparatore.component.ts